import React, { useEffect, useState } from "react";
import { Container, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import arrowLeft from "../assets/images/arrow-left.png";
import Checkbox from '@mui/material/Checkbox';
import { getChildrenForAttendance, markAttendance } from '../services/TeacherApi';
import LoadingSpinner from './LoadingSpinner';
import { showToast } from '../config/Alert';
import moment from 'moment';

const Attendance = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();
  const { slot } = location.state || {};
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const [attendanceData, setAttendanceData] = useState({});
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const currentDateTime = moment().format("DD MMM, YYYY hh:mm A");

  useEffect(() => {
    const fetchChildren = async () => {
      try {
        const response = await getChildrenForAttendance({
          time_slot_id: slot.time_slot_id,
          focus_id: slot.focus_id,
          day: slot.day,
          start_time: slot.start_time,
          end_time: slot.end_time,
          teacher_id: user.user_data.id,
        });
        setChildren(response.data.children);

        // Set default attendance (absent)
        const defaultAttendance = {};
        response.data.children.forEach(child => {
          defaultAttendance[child.id] = { status: "absent", remarks: "" };
        });
        setAttendanceData(defaultAttendance);
      } catch (error) {
        console.error("Failed to fetch children for attendance", error);
      } finally {
        setLoading(false);
      }
    };

    if (slot) {
      fetchChildren();
    }
  }, [slot]);

  const handleCheckboxChange = (childId, checked) => {
    setAttendanceData(prev => ({
      ...prev,
      [childId]: {
        ...prev[childId],
        status: checked ? "present" : "absent"
      }
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      program_id: slot.program_id,
      focus_id: slot.focus_id,
      skill_level_id: slot.skill_level_id,
      teacher_id: user.user_data.id,
      time_slot_id: slot.time_slot_id,
      day: slot.day,
      start_time: slot.start_time,
      end_time: slot.end_time,
      attendance: Object.entries(attendanceData).map(([child_id, details]) => ({
        child_id,
        status: details.status,
        remarks: details.remarks || ""
      }))
    };
    try {
      const res = await markAttendance(payload);
      setLoading(false);
      showToast("Attendance submitted successfully!", "success");
      navigate('/teacherDashboard');
    } catch (err) {
      console.error("Error submitting attendance:", err);
      showToast("Failed to submit attendance!", "error");
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className='app-container mobile-bottom'>
      <Container>

        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
            <Link to={`/attendanceTeacher/${slot.program_id}`} state={{ skillLevelId: slot.skill_level_id }}><img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Attendance</h2>
        </div>
        <div className="mt-3">
          <div className="d-flex justify-content-between">
            <h2 className='fs-20 fw-6 mb-1'>
              <span className='small-hello fs-14'>Hello, </span>
              <span className='bigg-name'>{user?.user_data.name}!</span>
              <p>
                <span className="fs-10 fw-normal">{slot?.program_name} {slot?.focus && (`- ${slot?.focus?.title}`)} - {slot?.skill_level_name} Class</span>
                <span className="d-block fs-10  fw-normal">{slot?.start_time} - {slot?.end_time} | {slot?.day_name}</span>
              </p>
            </h2>
            <div>
              <p className="fs-13 fw-6">{currentDateTime}</p>
            </div>
          </div>
          <div className='attendance py-3 mb-4 p-3 rounded-3'>

            <table className="w-100">
              <thead>
                <tr>
                  <th width="80%" className="text-danger fw-5">Name</th>
                  <th className="text-danger fw-5">Present</th>
                </tr>
              </thead>
              <tbody>
                {children.map((child, idx) => (
                  <tr key={idx}>
                    <td>{child.name}</td>
                    <td><Checkbox
                      {...label}
                      checked={attendanceData[child.id]?.status === "present"}
                      onChange={(e) => handleCheckboxChange(child.id, e.target.checked)}
                      color="success"
                    /></td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className='text-end mt-4'>
              <Button variant="danger" size="sm" onClick={handleSubmit}>Submit Attendance</Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Attendance;